import type { FaireProductEntity } from "../../entity_types/product";

export const p_vxpwwdsr62: FaireProductEntity = {
  token: "p_vxpwwdsr62",
  type: "product",
  name: "Sakura Block Print Tablecloth, Green",
  brandToken: "b_6jjy4txuzi",
  brandName: "",
  imageUrl:
    "https://cdn.faire.com/fastly/2150edc421da01f354059b90d5c96cbde600e25d1a5833d06448f1e0d56777ad.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/59f74117034e137b4472066d1e01a4ad6cac75f5513cb3bc6eb40af4fb37c703.jpeg",
    "https://cdn.faire.com/fastly/3622905c44da9a3d1a4117c0bdd8fca46af1c23d5c8285074785b10ecdcf0306.jpeg",
    "https://cdn.faire.com/fastly/faee502e31e33a0c56d7b058921d9153aba78f07bf0a6f22d04c1eff7fb9d36b.jpeg",
    "https://cdn.faire.com/fastly/cd8fb92c6ff7b573b5c4dc373d2cf9eec5679670345940fe8f0fd3854bd9853b.jpeg",
  ],
  priceDollars: 42,
  description:
    "Sakura Block Print Tablecloth, Green, A Handcrafted Favourite for Effortless Table Styling\r\n\r\nDress your dining table with the artisanal charm of the Sakura Block Print Tablecloth, Green. Crafted in India from 100% cotton and printed by hand using traditional block printing methods, this sustainable kitchen textile features a soothing green base with elegant fan-shaped floral sprays in soft blue tones. A detailed border completes the look, adding definition to your tablescape and enhancing its decorative appeal. Perfect for everyday meals or festive gatherings, it offers an elevated yet easygoing way to incorporate handcrafted kitchen textiles into your home.\r\n\r\nMaterials & Composition: 100% Cotton\r\n\r\nCare Instructions: Machine wash gentle with like colours. Hang to dry.\r\n\r\nFeatures & Benefits:\r\nHand block printed by skilled artisans in India\r\nSoft green ground with fan-style blue floral pattern\r\nContrasting border adds structure and elegance\r\nLightweight, breathable cotton for everyda",
  tags: [],
  msrpDollars: 84,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-07T04:57:33.481Z",
    importedBy: "gen-brand-update-tile-products.mjs",
  },
  categoryTokens: [],
};
